var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"store my-5 py-5"},[_c('b-container',[_c('h1',{staticClass:"main-heading text-center my-5 py-5"},[_vm._v(" "+_vm._s(_vm.$t("heading.all_projects"))+" ")]),_c('showcase',{staticClass:"showcase",attrs:{"items":_vm.items,"full-view":""}}),_c('subscribe',{staticClass:"my-5"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }